import { ark } from "@ark-ui/react/factory";
import { ComponentPropsWithoutRef, forwardRef } from "react";
import { css, cx } from "styled-system/css";

export interface SkeletonProps extends ComponentPropsWithoutRef<typeof ark.div> {
  /**
   * Class name for applying additional styles to the skeleton.
   * This will be needed to specify the dimensions of the skeleton.
   */
  className?: string;
}

/** A component for creating placeholder elements during loading states. */
export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, ...props }, ref) => {
    return <ark.div ref={ref} className={cx(skeletonStyles, className)} {...props} />;
  },
);
Skeleton.displayName = "Skeleton";

export const skeletonStyles = css({
  display: "inline-block",
  position: "relative",
  overflow: "hidden",
  bg: "skeleton",
  _after: {
    content: "''",
    position: "absolute",
    inset: "0",
    backgroundImage:
      "linear-gradient(90deg, token(colors.skeleton.shimmer1) 0%, token(colors.skeleton.shimmer2) 20%, token(colors.skeleton.shimmer3) 60%, token(colors.skeleton.shimmer1))",
    animationStyle: "shimmer",
  },
});
